
//公共库
import { Component, Vue } from "vue-property-decorator";

//本地引入
import { MessageBox } from "element-ui";
import Pagination from "@/comp/Pagination/index.vue";
import { wordsList, savePendingWords, pendingWordsList, wordsCategoryList, removeWords, saveWords, batchAddWords, detectWords } from "@/api/request/system";
import { parseTime } from "@/utils";

//组件
@Component({
  name: "Words",
  components: {
    Pagination,
  },
})

//界面函数
export default class extends Vue {
  //定义变量
  private list: any[] = [];
  private total: number = 0;
  private listLoading: boolean = true;
  private categoryList: Array<any> = [];
  private categorySelect: Array<any> = [];

  //请求参数
  private listQuery: any = {
    //页码数据
    page: 1,
    page_size: 20,

    //上传数据
    word: "", //敏感词
    cat_id: 0, //分类ID
  };

  //创建
  async created() {
    //获取类别
    await this.getCategory();

    //获取数据
    this.getList();
  }

  //获取数据
  private async getList() {
    //显示等待
    this.listLoading = true;

    //获取数据
    const { data } = await wordsList(this.listQuery);

    //数据赋值
    this.list = data.list;
    this.total = data.total;

    //隐藏等待
    setTimeout(() => {
      this.listLoading = false;
    }, 0.5 * 1000);
  }

  //获取类别列表
  private async getCategory() {
    //显示等待
    this.listLoading = true;

    //获取数据
    const { data } = await wordsCategoryList(this.listQuery);

    //数据赋值
    this.categoryList = [];
    this.categorySelect = [];
    for (var i: number = 0; i < data.length; i++) {
      this.categoryList.push(data[i]);
      this.categorySelect.push(data[i]);
    }
    this.categoryList.unshift({ id: 0, name: "全部分类" });
    this.categorySelect.unshift({ id: 0, name: "请选择分类" });
  }

  //监测敏感词
  private handleCheck(): void {
    //数据赋值
    this.checkWord = "";
    this.checkResult = [];
    this.checkDialogVisible = true;
  }

  //处理查询
  private handleFilter(): void {
    //数据赋值
    this.listQuery.page = 1;

    //获取数据
    this.getList();
  }

  //处理创建
  private handleCreate(): void {
    //数据赋值
    this.addForm = {
      id: 0,
      word: "",
      words: [],
      cat_id: 0,
    };
    this.addType = 1;
    this.tagInput = "";
    this.dialogStatus = "create";

    //显示界面
    this.dialogVisible = true;
  }

  //批量处理创建
  private handleCreates(): void {
    //数据赋值
    this.addForm = {
      id: 0,
      word: "",
      words: [],
      cat_id: 0,
    };
    this.addType = 2;
    this.tagInput = "";
    this.dialogStatus = "creates";

    //显示界面
    this.dialogVisible = true;
  }

  //待审核列表
  private handleReadyList(): void {
    //显示界面
    this.readyQuery = {
      page: 1,
      word: "",
      page_size: 10,
    };
    this.readyList = [];
    this.readyTotal = 0;
    this.multipleSelection = [];

    //显示界面
    this.readyDialogVisible = true;

    //获取数据
    this.getReadyList();
  }

  //处理编辑
  private handleUpdate(row: any): void {
    //数据赋值
    this.addForm = {
      words: [],
      id: row.id,
      word: row.word,
      cat_id: row.cat_id,
    };
    this.tagInput = "";
    this.dialogStatus = "update";

    //显示界面
    this.dialogVisible = true;
  }

  //处理删除
  private handleDelete(row: any): void {
    //显示提示
    MessageBox.confirm("删除操作不可恢复，确定删除吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        //处理删除操作
        await removeWords({ ids: [row.id] });

        //显示提示
        this.$notify({
          title: "成功",
          message: "删除成功",
          type: "success",
          duration: 2000,
        });

        //获取列表
        this.getList();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //--------------------------------- 添加/编辑 ---------------------------------
  //定义变量
  private addType: number = 1;
  private tagInput: string = "";
  private tagInputMore: string = "";
  private dialogStatus: string = "";
  private dialogVisible: boolean = false;
  private dialogLoading: boolean = false;
  private titleMap = { update: "编辑敏感词", create: "新增敏感词", creates: "批量新增敏感词" };

  //添加表单
  private addForm: any = {
    id: 0,
    word: "",
    words: [],
    cat_id: 0,
  };

  //创建敏感词
  private async createData() {
    //数据处理
    if (this.addForm.cat_id == 0) return this.$message.error("请选择类别");
    if (this.addForm.word == "" && this.addType == 1) return this.$message.error("请选输入敏感词");
    if (this.addForm.words.length == 0 && this.addType == 2) return this.$message.error("请选添加敏感词");

    //显示等待
    this.dialogLoading = true;

    //添加敏感词
    if (this.addType == 1) {
      await saveWords(this.addForm);
    }
    //批量添加敏感词
    else {
      await batchAddWords(this.addForm);
    }

    //隐藏等待
    this.dialogLoading = false;

    //隐藏界面
    this.dialogVisible = false;

    //显示提示
    this.$notify({
      title: "成功",
      message: "创建成功",
      type: "success",
      duration: 2000,
    });

    //获取列表
    this.getList();
  }

  //更新敏感词
  private async updateData() {
    //数据处理
    if (this.addForm.name == "") return this.$message.error("请输入敏感词");
    if (this.addForm.cat_id == 0) return this.$message.error("请选择类别");

    //显示等待
    this.dialogLoading = true;

    //保存任务
    await saveWords(this.addForm);

    //隐藏等待
    this.dialogLoading = false;

    //隐藏界面
    this.dialogVisible = false;

    //显示提示
    this.$notify({
      title: "成功",
      message: "编辑成功",
      type: "success",
      duration: 2000,
    });

    //获取列表
    this.getList();
  }

  //是否创建
  private isCreate(): boolean {
    return this.dialogStatus === "create" || this.dialogStatus === "creates";
  }

  //添加敏感词
  private addTag(type: string): void {
    //批量添加
    if (type === "more") {
      //判断赋值
      if (this.tagInputMore.trim() !== "") {
        //数据处理
        this.tagInputMore
          .trim()
          .split(",")
          .forEach((item) => {
            this.addForm.words.push(item.trim());
            this.tagInputMore = ""; // 清空输入框
          });
      } else {
        //显示提示
        this.$message.error("请输入敏感词");

        //清空输入框
        this.tagInput = "";
      }
    }
    //单独添加
    else {
      //判断赋值
      if (this.tagInput.trim() !== "") {
        //数据赋值
        this.addForm.words.push(this.tagInput.trim());

        //清空输入框
        this.tagInput = "";
      } else {
        //显示提示
        this.$message.error("请输入敏感词");

        //清空输入框
        this.tagInput = "";
      }
    }
  }

  //移除ID
  private removeTag(index: any): void {
    //数据赋值
    this.addForm.words.splice(index, 1);
  }

  //--------------------------------- 监测敏感词 ---------------------------------
  //定义变量
  private checkWord: string = "";
  private checkResult: Array<any> = [];
  private checkDialogVisible: boolean = false;
  private checkDialogLoading: boolean = false;

  //清空监测
  private cleanCheck(): void {
    //清空数据
    this.checkWord = "";
    this.checkResult = [];
  }

  //创建消息
  private async checkData() {
    //判断返回
    if (this.checkWord == "") return this.$message.error("请输入监测内容");

    //显示等待
    this.checkDialogLoading = true;

    //监测文本
    const { data } = await detectWords({ text: this.checkWord });

    //数据赋值
    this.checkResult = data;

    //隐藏等待
    this.checkDialogLoading = false;
  }

  //--------------------------------- 待审核列表 ---------------------------------
  //定义变量
  private readyTotal: number = 0;
  private readyList: Array<any> = [];
  private multipleSelection: Array<any> = [];
  private readyDialogVisible: boolean = false;
  private readyDialogLoading: boolean = false;

  //添加表单
  private readyQuery: any = {
    page: 1,
    word: "",
    page_size: 10,
  };

  //获取数据
  private async getReadyList() {
    //显示等待
    this.readyDialogLoading = true;

    //获取数据
    const { data } = await pendingWordsList(this.readyQuery);

    //数据赋值
    this.readyList = data.list;
    this.readyTotal = data.total;

    //隐藏等待
    setTimeout(() => {
      this.readyDialogLoading = false;
    }, 0.5 * 1000);
  }

  //处理删除
  private async handleDeleteReady() {
    //显示提示
    MessageBox.confirm("删除操作不可恢复，确定删除吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        //数据赋值
        var ids: Array<number> = [];
        for (var i: number = 0; i < this.multipleSelection.length; i++) {
          ids.push(this.multipleSelection[i].id);
        }

        //显示等待
        this.readyDialogLoading = true;

        //保存敏感词
        await savePendingWords({ ids: ids, status: 2 });

        //显示提示
        this.$notify({
          title: "成功",
          message: "删除成功",
          type: "success",
          duration: 2000,
        });

        //获取列表
        this.getReadyList();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //处理确认
  private async handleConfirmReady() {
    //显示提示
    MessageBox.confirm("确认审核敏感词吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "info",
    })
      .then(async () => {
        //数据赋值
        var ids: Array<number> = [];
        for (var i: number = 0; i < this.multipleSelection.length; i++) {
          ids.push(this.multipleSelection[i].id);
        }

        //显示等待
        this.readyDialogLoading = true;

        //保存敏感词
        await savePendingWords({ ids: ids, status: 1 });

        //显示提示
        this.$notify({
          title: "成功",
          message: "审核成功",
          type: "success",
          duration: 2000,
        });

        //获取列表
        this.getReadyList();

        //获取列表
        this.getList();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //处理查询
  private handleReadyFilter(): void {
    //数据赋值
    this.readyQuery.page = 1;

    //获取数据
    this.getReadyList();
  }

  //选择
  private handleSelectionChange(val: Array<any>): void {
    //数据赋值
    this.multipleSelection = val;
  }

  //处理时间
  private handleTime(time: number): string {
    return parseTime(time) as string;
  }
}
